var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerifiedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.367 10.1809C41.5036 10.1809 50.5339 19.1992 50.5532 30.3313C52.203 30.7681 53.7516 31.4536 55.1565 32.3453C55.2079 31.6926 55.234 31.0329 55.234 30.367C55.234 16.6333 44.1007 5.5 30.367 5.5C16.6333 5.5 5.5 16.6333 5.5 30.367C5.5 44.1007 16.6333 55.234 30.367 55.234C31.0329 55.234 31.6926 55.2079 32.3453 55.1565C31.4536 53.7516 30.7681 52.203 30.3313 50.5532C19.1992 50.5339 10.1809 41.5036 10.1809 30.367C10.1809 19.2185 19.2185 10.1809 30.367 10.1809Z",
    fill: "#C4CDE0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6471 47.8625V39.1471H48.2059V47.8625H44.6471Z",
    fill: "#C4CDE0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6471 49.6056H48.2059V53.3824H44.6471V49.6056Z",
    fill: "#C4CDE0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5 46.3112C60.5 54.1474 54.1474 60.5 46.3112 60.5C38.4749 60.5 32.1223 54.1474 32.1223 46.3112C32.1223 38.4749 38.4749 32.1223 46.3112 32.1223C54.1474 32.1223 60.5 38.4749 60.5 46.3112ZM55.8191 46.3112C55.8191 51.5623 51.5623 55.8191 46.3112 55.8191C41.0601 55.8191 36.8032 51.5623 36.8032 46.3112C36.8032 41.0601 41.0601 36.8032 46.3112 36.8032C51.5623 36.8032 55.8191 41.0601 55.8191 46.3112Z",
    fill: "#C4CDE0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14.5588H28.1471V28.1471H19.4118V33H33V14.5588Z",
    fill: "#C4CDE0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifiedIcon);
export default __webpack_public_path__ + "static/media/verifiedIcon.3938908af80f4615568d64ff66ae83f8.svg";
export { ForwardRef as ReactComponent };